import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';

import Popup from './Popup';

export default function Index({ enterpriseId, userToken, locked }) {
  const [showPopup, setShowPopup] = useState(false);

  const onBlockClicked = () => {
    setShowPopup(true);
  };

  const onPopupClose = () => {
    setShowPopup(false);
  };

  return (
    <>
      <Button
        onClick={onBlockClicked}
        bsStyle="green"
        className="w-100"
      >
        {locked ? 'Unlock' : 'Block'}
      </Button>
      {showPopup && (
      <Popup
        enterpriseId={enterpriseId}
        onHide={onPopupClose}
        userToken={userToken}
        onComplete={() => window.location.reload()}
      />
      )}
    </>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  userToken: PropTypes.string.isRequired,
  locked: PropTypes.bool.isRequired,
};
